export const getSelectedCorporate = (corporateId) => {
  return {
    type: "SELECTED_CORPORATE",
    payload: corporateId
  };
};

export const toggleChangeConfiguration = (view) => {
  return {
    type: "CHANGE_CONFIGURATION",
    payload: view
  };
};




